const newsList = {
  state: {
    /*公司新闻
    * Id 该新闻唯一标识，不可重复
    * Title 新闻标题
    * Img 图片链接 只需要修改require里面的路径（图片存放于assets/img/newsList/companyNews文件夹中）
    * Content 内容
    * CreateTime 创建时间
    * */
    companyNewsList: [
      {
        "Id": 23,
        "Title": "KL接线箱",
        "Img": require('../../assets/img/newsList/companyNews/KL接线箱.jpg'),
        "Content": "KL接线箱",
        "CreateTime": "2019-04-25T09:13:08.51"
      }, {
        "Id": 21,
        "Title": "L型悬臂箱",
        "Img": require('../../assets/img/newsList/companyNews/L型悬臂箱.jpg'),
        "Content": "L型悬臂箱",
        "CreateTime": "2018-09-29T19:04:52.56"
      }, {
        "Id": 19,
        "Title": "PC电脑柜",
        "Img": require('../../assets/img/newsList/companyNews/PC电脑柜.jpg'),
        "Content": "PC电脑柜",
        "CreateTime": "2018-09-17T19:46:46.673"
      }
    ],

    /*最新资讯
    * Id 该新闻唯一标识，不可重复
    * Title 新闻标题
    * Img 图片链接 只需要修改require里面的路径（图片存放于assets/img/newsList/latestNews文件夹中）
    * Content 内容
    * CreateTime 创建时间
    * */
    latestNewsList: [{
      "Id": 18,
      "Title": "PS九折柜",
      "Img": require('../../assets/img/newsList/latestNews/PS九折柜.jpg'),
      "Content": "PS九折柜",
      "CreateTime": "2018-08-08T10:59:07.677"
    }, {
      "Id": 17,
      "Title": "U型悬臂箱 ",
      "Img": require('../../assets/img/newsList/latestNews/U型悬臂箱.jpg'),
      "Content": "U型悬臂箱",
      "CreateTime": "2018-08-08T10:53:13.023"
    }],
  },
};

export default newsList